import React, { Suspense } from 'react';

const VimeoComponent = React.lazy(() => import('./Vimeo'));

export const Vimeo = (props) => (
  <Suspense fallback={null}>
    <VimeoComponent {...props} />
  </Suspense>
);
